<div class="center-xy font-14">
    <div style="height: max-content;">
        <div class="mainControl"
            [ngStyle]="{ overflow: control.overflow ? 'auto' : 'hidden'}">
            <div class="control color-light"
                *ngIf="control.elementVal"
                [ngSwitch]="template">
                <checkbox *ngSwitchCase="'checkbox'"></checkbox>
                <checkbox-expanded *ngSwitchCase="'checkbox-expanded'"></checkbox-expanded>
                <date-interval *ngSwitchCase="'date-interval'"></date-interval>
                <date-format-control *ngSwitchCase="'date-format-control'"></date-format-control>
                <date-picker-control *ngSwitchCase="'date-picker-control'"></date-picker-control>
                <data-table *ngSwitchCase="'data-table'"></data-table>
                <data-table-different *ngSwitchCase="'data-table-different'"></data-table-different>
                <group-code *ngSwitchCase="'group-code'"></group-code>
                <heating-curve *ngSwitchCase="'heating-curve'"></heating-curve>
                <heating-curve-chart *ngSwitchCase="'heating-curve-chart'"></heating-curve-chart>
                <heating-curve-shift *ngSwitchCase="'heating-curve-shift'"></heating-curve-shift>
                <input-control *ngSwitchCase="'input'"></input-control>
                <manufacturer-data *ngSwitchCase="'manufacturer-data'"></manufacturer-data>
                <on-off *ngSwitchCase="'on-off'"></on-off>
                <one-switch *ngSwitchCase="'one-switch'"></one-switch>
                <schedule-intervals *ngSwitchCase="'schedule-intervals'"></schedule-intervals>
                <schedule-multi *ngSwitchCase="'schedule-multi'"></schedule-multi>
                <schedule-on-off *ngSwitchCase="'schedule-on-off'"></schedule-on-off>
                <schedule-plus-minus *ngSwitchCase="'schedule-plus-minus'"></schedule-plus-minus>
                <select-box *ngSwitchCase="'select-box'"></select-box>
                <time-mode *ngSwitchCase="'time-mode'"></time-mode>
                <two-switch *ngSwitchCase="'two-switch'"></two-switch>
                <yes-no *ngSwitchCase="'yes-no'"></yes-no>
            </div>
            <div class="control__background-shadow bg-light-shadow"
                 *ngIf="scheduleIntervals.showRange || scheduleIntervals.showWeekDays">
            </div>
        </div>
    </div>
</div>
